import airDropRequest from '@/utils/airDropRequest'

export const getAbi = (name) => {
  return airDropRequest({
    url: `/api/v1.0/tokenlocker/contracts/abi/${name}`,
    method: 'get'
  })
}

// /api/v1.0/tokenlocker/hasRecords/:userAddress
export function getHasRecords(userAddress) {
  return airDropRequest({
    url: `/api/v1.0/tokenlocker/hasRecords/${userAddress}`,
    method: 'get'
  })
}

// api/v1.0/tokenlocker/unclaimedTokens/:userAddress
export function getUnclaimedTokens(userAddress) {
  return airDropRequest({
    url: `/api/v1.0/tokenlocker/unclaimedTokens/${userAddress}`,
    method: 'get'
  })
}

// /api/v1.0/tokenlocker/agreement/:userAddres
export function getAgreement(userAddress) {
  return airDropRequest({
    url: `/api/v1.0/tokenlocker/agreement/${userAddress}`,
    method: 'get'
  })
}

//    app.post('/api/v1.0/tokenlocker/agreement', createAgreementValidator, this.createAgreement);
// userAddress
export function createAgreement(data) {
  return airDropRequest({
    url: '/api/v1.0/tokenlocker/agreement',
    method: 'post',
    data
  })
}
